// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".category-bc-layer{z-index:8000;position:fixed;top:0;left:0;right:0;bottom:0;background-color:#09f;box-shadow:0px 0px 4px 1px grey}\n", ""]);
// Exports
module.exports = exports;
